import { QBox, QStack, QText } from '@qualio/ui-components';

const ItemWithIdAndNameLabel = ({
  itemName,
  itemId,
  setMinWidth,
}: {
  itemName: string;
  itemId: string;
  setMinWidth: boolean;
}) => (
  <QStack display="inline-flex" isInline maxWidth="222px">
    <QBox minWidth={setMinWidth ? '70px' : undefined}>
      <QText
        title={itemId}
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        overflow="hidden"
        maxWidth="70px"
        textTransform="none"
        color="gray.800"
        background="gray.100"
        fontSize="xs"
        fontWeight="semibold"
        borderRadius="sm"
        display="inline-block"
        verticalAlign="middle"
        paddingInlineStart="1"
        paddingInlineEnd="1"
      >
        {itemId}
      </QText>
    </QBox>
    <QText title={itemName} textOverflow="ellipsis" overflow="hidden">
      {itemName}
    </QText>
  </QStack>
);

export default ItemWithIdAndNameLabel;
